<template>
  <div style="min-width:calc(100% + 44px);margin-left: -20px;margin-right: -24px;">
    <div style="height:80px;width:100%">
      <v-btn icon @click="$router.back()">
        <v-icon color="black">arrow_back</v-icon>
      </v-btn>
      <v-btn icon style="float:right" @click="toBotoom()">
        <v-icon color="green">view_kanban</v-icon>
      </v-btn>
      <h2 style="text-align: center">{{ schema.name }}</h2>
    </div>
    <v-layout style="min-width: 100%;max-height:calc(100% - 88px);overflow-y: visible;" wrap>
      <div ref="kanbanWrapper" class="kanbanWrapper">
        <div v-for="value in kanbanField.values" v-if="kanbanField" :id="'dropzone_' + value.key" class="dropzone">
          <div class="kanban-name">{{ value.value }}</div>
          <div v-for="form in forms">
            <div v-if="canDisplayForm(form,value.key)" :id="'Drag_'+form.id" :class="'drag'" :style="'background:' + getColor(value.key) "
                 draggable="true">
              <v-layout>
                <v-flex fill-height style="margin: .7rem 0;vertical-align: center;" xs11>
                  {{ getFormName(form) }}
                </v-flex>
                <v-flex style="margin: .7rem 0;" xs1>

                  <v-dialog v-model="form._dialog">
                    <template v-slot:activator="{ on }">
                      <v-icon color="white" style="cursor: pointer;font-size: 1.2rem;padding-right: .5rem;" v-on="on">
                        info
                      </v-icon>
                    </template>
                    <div>
                      <SingleView v-if="form._dialog" :allow-edit="true" :form-id="form.id" :schema-id="schema.id"
                                  @delete="deleteForm($event)"></SingleView>
                    </div>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </div>
    </v-layout>
  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger"
import SingleView from "@/components/form/SingleView.vue"
import NameTemplates from "@/helpers/NameTemplates"
import {error} from "eslint/lib/shared/logging"

export default {
  components: {SingleView},
  data() {
    return {
      kanban: {},
      kanbanField: {},
      forms: [],
      schema: {},
      nameTemplates: new NameTemplates()
    }
  },
  created() {

    let kanban = this.$http.get(`schema/${this.$route.params.schemaId}/kanban/first`)
    let schema = this.$http.get(`schema/${this.$route.params.schemaId}`)
    let form = this.$http.get(`form/${this.$route.params.schemaId}?pageSize=1000`)

    Promise.all([kanban, schema, form]).then((data) => {
      this.kanban = data[0].data
      this.schema = data[1].data
      this.fields = data[1].data.fields
      this.kanbanField = this.fields.find(el => el.id == data[0].data.field_id)
      this.forms = data[2].data

      setTimeout(this.addListeners, 500)

    }).catch(() => Messenger.emitError("Bład podczas łądowania"))


  },
  mounted() {
    setTimeout(() => this.$refs.kanbanWrapper.height = this.$refs.kanbanWrapper.parentElement.parentElement.getBoundingClientRect().height, 500)
  },
  methods: {
    toBotoom() {
      window.scrollTo(0, document.body.scrollHeight)
    },
    getColor(key) {
      switch (key) {
      case 1:
        return 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,15,121,1) 0%, rgba(22,31,182,1) 50%, rgba(9,15,121,1) 100%, rgba(9,15,121,1) 100%, rgba(3,139,206,1) 100%, rgba(0,212,255,1) 100%);'
      case 2:
        return 'radial-gradient(circle, rgba(115,45,3,1) 0%, rgba(71,27,2,1) 100%);'
      case 3:
        return 'radial-gradient(circle, rgba(142,150,92,1) 0%, rgba(96,107,28,1) 100%);'
      case 4:
        return 'radial-gradient(circle, rgba(135,81,14,1) 0%, rgba(93,67,35,1) 100%);'
      case 5:
        return 'radial-gradient(circle, rgba(5,97,19,1) 0%, rgba(28,98,0,1) 100%);'
      case 6:
        return 'radial-gradient(circle, rgba(111,8,87,1) 0%, rgba(66,13,54,1) 100%);'
      case 7:
        return 'radial-gradient(circle, rgba(64,19,131,1) 0%, rgba(47,14,98,1) 100%);'
      case 8:
        return 'radial-gradient(circle, rgba(179,25,25,1) 0%, rgba(185,8,8,1) 100%);'
      case 9:
        return 'radial-gradient(circle, rgba(78,92,0,1) 0%, rgba(97,110,27,1) 100%);'
      case 10:
        return 'linear-gradient(90deg, rgba(147,75,206,1) 0%, rgba(180,86,196,1) 50%, rgba(192,0,165,1) 100%);'
      case 11:
        return 'radial-gradient(circle, rgba(140,85,87,1) 0%, rgba(125,68,70,1) 100%);'
      case 12:
        return 'radial-gradient(circle, rgba(120,135,87,1) 0%, rgba(125,130,70,1) 100%);'
      case 13:
        return 'radial-gradient(circle, rgba(40,85,87,1) 0%, rgba(25,68,70,1) 100%);'
      default:
        return '#424f1b'
      }
    },
    getFormName(form) {
      return this.nameTemplates.encode(this.kanban.name_template, form)
    },
    canDisplayForm(form, valueKey) {
      let fieldResult = form.results.find(el => el.order == this.kanbanField.order)
      if (!fieldResult) {
        return false
      }

      return fieldResult.value == valueKey
    },
    deleteForm(id) {
      this.$confirm(this.$t('form.delete.confirmation'))
          .then(res => {
            if (res) {
              let form = this.forms.find(f => f.id == id)

              if (!form) {
                throw error("Form not exist!")
              }

              form._dialog = false
              this.$http.delete('form', {
                data: {
                  schema_id: this.$route.params.schemaId,
                  form_id: id,
                }
              }).then(() => {
                this.forms = this.forms.filter(f => f.id != id)
                this.$store.commit('setSnack', {
                  message: this.$t('form.delete.success-message'),
                  color: 'success'
                })
              })
                  .catch(() => {
                    this.$store.commit('setSnack', {
                      message: this.$t('form.delete.error-message'),
                      color: 'danger'
                    })
                  })
            }
          })
    },
    addListeners() {
      document.querySelectorAll('.drag').forEach(el => {
        el.addEventListener("dragstart", (event) => {
          event.dataTransfer.setData('id', event.target.id)
        })
      })


      document.querySelectorAll('.dropzone').forEach(target => {
        target.addEventListener("dragover", (event) => {
          event.preventDefault()
        })


        target.addEventListener("drop", (event) => {
          let dragged = document.querySelector('#' + event.dataTransfer.getData('id'))
          if (!dragged) {
            return
          }
          let formId = event.dataTransfer.getData('id').slice(5)
          let value = target.id.slice(9) //dropzone_ID

          this.$http.put(`form/${this.schema.id}/${formId}`, {
            id: formId,
            results: [{order: this.kanbanField.order, value}]
          }).then(data => {
            this.forms.find(el => el.id == formId).results.find(el => el.order == this.kanbanField.order).value = value
            setTimeout(() => {
              let dragged = document.querySelector('#' + event.dataTransfer.getData('id'))
              dragged.addEventListener("dragstart", (event) => {
                event.dataTransfer.setData('id', event.target.id)
              })
            }, 200)
          })

          // dragged.parentNode.removeChild(dragged);
          // target.appendChild(dragged);
        })
      })
    }
  },
}

</script>

<style scoped>

.drag {
  border-radius: 10px 10px;
  border: 1px solid black;
  user-select: none;
  text-align: center;
  color: white;
  vertical-align: center;
  background: #c7f50b;
  margin-top: 5px;
  font-weight: 600;
  min-height: 3rem;
  text-shadow: .5px .5px black;
}

#draggable2 {
  text-align: center;
  background: #221781;
}

#draggable3 {
  text-align: center;
  background: #ad8b34;
}

.dropzone {
  flex: 1;
  align-items: stretch;
  min-width: 200px;
  border-left: 1px gray dashed;
  border-right: 1px gray dashed;
  background: #fff;
  padding-bottom: 30px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;
  float: left;
  scrollbar-color: #bcf0ff #d0d0d0;
  scrollbar-width: thin;
}

.kanbanWrapper {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex-wrap: nowrap;
  min-height: calc(100vh - 90px);
  min-width: 100%;
  max-height: calc(100vh - 90px);
  overflow-x: scroll;
}

.kanban-name {
  text-align: center;
  background-color: #183750;
  border-radius: 0px 15px 15px 0px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 1.1rem;
  text-align: center;
  color: white;
  text-shadow: .4px .4px black;
}
</style>